import { render, staticRenderFns } from "./MobileItems.vue?vue&type=template&id=6f14d168"
import script from "./MobileItems.vue?vue&type=script&lang=js"
export * from "./MobileItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports